import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/I18nContext";
import { LangGate, RedirectToLang } from "@/i18n/LangRouting";
import { PlayerProvider } from "@/visitor/PlayerContext";
import LanguageSheet from "@/visitor/LanguageSheet";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ExhibitionShell from "@/visitor/ExhibitionShell";
import SignupPage from "@/visitor/SignupPage";
import VoucherPage from "@/visitor/VoucherPage";
import ArtworkListPage from "@/visitor/ArtworkListPage";
import ArtworkDetailPage from "@/visitor/ArtworkDetailPage";
import { AdminProvider } from "@/admin/AdminContext";
import AdminLogin from "@/admin/AdminLogin";
import AdminSetPassword from "@/admin/AdminSetPassword";
import AdminLayout from "@/admin/AdminLayout";
import ArtworksAdmin from "@/admin/ArtworksAdmin";
import ArtworkEditor from "@/admin/ArtworkEditor";
import LanguagesAdmin from "@/admin/LanguagesAdmin";
import UiTextsAdmin from "@/admin/UiTextsAdmin";
import LegalAdmin from "@/admin/LegalAdmin";
import ExhibitionsAdmin from "@/admin/ExhibitionsAdmin";
import ExhibitionEditor from "@/admin/ExhibitionEditor";
import MatrixAdmin from "@/admin/MatrixAdmin";
import AdminsAdmin from "@/admin/AdminsAdmin";
import SignupsAdmin from "@/admin/SignupsAdmin";

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
      <I18nProvider>
        <PlayerProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminProvider><AdminLogin /></AdminProvider>} />
            <Route path="/admin/setup/:token" element={<AdminProvider><AdminSetPassword mode="setup" /></AdminProvider>} />
            <Route path="/admin/reset/:token" element={<AdminProvider><AdminSetPassword mode="reset" /></AdminProvider>} />
            <Route path="/admin" element={<AdminProvider><AdminLayout /></AdminProvider>}>
              <Route index element={<Navigate to="artworks" replace />} />
              <Route path="artworks" element={<ArtworksAdmin />} />
              <Route path="artworks/:id" element={<ArtworkEditor />} />
              <Route path="languages" element={<LanguagesAdmin />} />
              <Route path="texts" element={<UiTextsAdmin />} />
              <Route path="legal" element={<LegalAdmin />} />
              <Route path="exhibitions" element={<ExhibitionsAdmin />} />
              <Route path="exhibitions/:id" element={<ExhibitionEditor />} />
              <Route path="matrix" element={<MatrixAdmin />} />
              <Route path="admins" element={<AdminsAdmin />} />
              <Route path="signups" element={<SignupsAdmin />} />
            </Route>
            <Route path="/:lang" element={<LangGate />}>
              <Route index element={<Home />} />
              <Route path="legal/:key" element={<LegalPage />} />
              <Route path="signup" element={<SignupPage general />} />
              <Route path="e/:slug" element={<ExhibitionShell />}>
                <Route index element={<ArtworkListPage />} />
                <Route path="signup" element={<SignupPage />} />
                <Route path="voucher" element={<VoucherPage />} />
                <Route path="a/:artworkId" element={<ArtworkDetailPage />} />
              </Route>
              <Route path="*" element={<RedirectToLang />} />
            </Route>
            <Route path="*" element={<RedirectToLang />} />
          </Routes>
          <LanguageSheet />
        </PlayerProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
